/**
 * Initializes global client-side behavior for the Amblunz theme.
 */

// Code in partials.



document.addEventListener('DOMContentLoaded', function() {
  // Only run on desktop (for example, >1024px)
//   if (window.innerWidth < 1024) return;

//   const stickyBtn = document.querySelector('.apply-now-btn-sticky');
//   const bottomContainer = document.querySelector('.apply-now-container-bottom');

//   if (!stickyBtn || !bottomContainer) return;

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         stickyBtn.classList.add('hidden');
//       } else {
//         stickyBtn.classList.remove('hidden');
//       }
//     });
//   }, {
//     root: null,
//     threshold: 0.1
//   });

//   observer.observe(bottomContainer);


});